export default "__VITE_ASSET__D9dA_tQ0__"